import React, { type ReactNode } from 'react';
import styled from '@emotion/styled';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';
import { typeStyle } from 'constants/typography';

export type MenuSectionTitle = {
  key: string;
  title: ReactNode;
  isSectionTitle: true;
};

type NavbarMenuSectionTitleProps = {
  item: MenuSectionTitle;
};

/** Figma's section label has no rule and antd's Divider always draws one, so this is a plain label. */
const NavbarMenuSectionTitle: React.FunctionComponent<NavbarMenuSectionTitleProps> = ({ item }) => {
  const { isCollapsed } = useNavbarCollapse();

  return (
    <SectionLabelContainer data-e2e={item.key}>
      {!isCollapsed && <SectionLabel>{item.title}</SectionLabel>}
    </SectionLabelContainer>
  );
};

/**
 * Figma nests each group in its own column at 16/8/4; the rail renders one flat list, so the label
 * carries the difference on top of PanelSection's 4px gap.
 */
const SectionLabelContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 var(--padding-md);
  margin-top: var(--padding-md);
  margin-bottom: var(--spacing-xxxs);
`;

const SectionLabel = styled.span`
  ${typeStyle.labelMd}
  color: var(--text-body-on-dark);
`;

export default NavbarMenuSectionTitle;
